<div class="flex flex-col">
    @for (serialData of serials(); track serialData) {
        <div class="p-1" [class.invalid-serial]="serialData.serialError?.length > 0">
            <app-phx-input-serial-number-with-warehouse
                [requiredAmount]="1"
                [reverse]="reverse()"
                [(value)]="serialData.serialNumber"
                (textChanged)="onTextChanged(serialData, $index, $event)"
                (validSerialChanged)="onValidSerialChanged(serialData, $index, $event)"
                [ignoreStoragePlace]="storagePlaceId() ? false : true"
                [storagePlaceId]="storagePlaceId()"
                [product]="product()"
                [disabled]="disabled()"
                showIconFirst="true"
                (focus)="onFocus(serialData)"
                (blur)="onBlur(serialData)"
                [attr.data-testid]="'formly-serial-number-field-' + $index"
            />
            @if (serialData.serialError?.length > 0) {
                <span class="text-red-700 text-xs ml-5" style="font-style: italic">{{
                    'common.' + serialData.serialError | translate
                }}</span>
            }
        </div>
    }
</div>
